import React from 'react';
import { observer } from 'mobx-react-lite';
import { ResultDialog } from './ResultDialog';
import resultDialog from 'stores/resultDialog';

export const GlobalResultDialog = observer(() => {
    return (
        <ResultDialog
            open={resultDialog.open}
            type={resultDialog.type}
            title={resultDialog.title}
            text={resultDialog.text}
            onClose={resultDialog.onClose}
            confirmText={resultDialog.confirmText}
            hideClose={resultDialog.hideClose}
            content={resultDialog.content}
        />
    );
});
